
import { useImpressionStore } from '@/stores/impression'

export default defineNuxtPlugin((nuxtApp) => {
  const impressionStore = useImpressionStore()
  const publicConfig = useRuntimeConfig().public

  nuxtApp.$router.afterEach((to, from, failure) => {
    console.log(failure)
    if (failure) return
    // if (dataLayer) {
    //   dataLayer?.push({
    //     event: "nuxtRoute",
    //     target: null,
    //     action: null,
    //     "target-properties": null,
    //     value: null,
    //     "interaction-type": false,
    //     pageType: 'PageView',
    //     pageUrl: `/${nuxtApp?.$config?.public?.chainKey}/${nuxtApp?.$config?.public?.paddingedChainId}${to?.fullPath}`,
    //     routeName: to?.name,
    //     pageTitle: (typeof document !== 'undefined' && document?.title) || '',
    //   });
    //   // console.log(dataLayer)
    // }
    setTimeout(() => {
      // PageView GA発火
      if (nuxtApp?.$pushGtmMountedTrigger) {
        nuxtApp.$pushGtmMountedTrigger()
      }

      // PageView インプレッション発火
      // const page = `/${publicConfig.chainKey}/${publicConfig.paddingedChainId}${to.fullPath}`
      const page = `${to.fullPath}`
      let id

      if (to.name === 'content') {
        id = to.params.id
      } else if (to.name === 'product') {
        id = to.query.jan
      }
      
      impressionStore.sendPVImpression({
        id,
        shopId: to.query?.['shop-id'],
        flyerId: to.query?.['id'],
        detailId: to.query?.['detail-id'],
        page,
      })
    }, 250)
  })
})